(function (angular) {
	angular.module('bizPartEngage').directive('bizNotifications', bizNotifications);
	angular.module('bizPartEngage').constant('notificationSettingType', {
		FAB: 1,
		STANDARD: 2,
		DIALOG: 3,
	});
	angular.module('bizPartEngage').constant('notificationPosition', {
		TOPLEFT: 1,
		TOPRIGHT: 2,
		BOTTOMLEFT: 3,
		BOTTOMRIGHT: 4,
		CENTER: 5,
	});
	angular.module('bizPartEngage').provider('bizNotificationProvider', bizNotificationProvider);
	angular.module('bizPartEngage').service('bizNotificationService', bizNotificationService);

	bizNotifications.$inject = [
		'bizCore',
		'bizNotificationProvider',
		'notificationSettingType',
		'notificationPosition',
		'bizNotificationService',
	];
	bizNotificationProvider.$inject = ['notificationSettingType'];
	bizNotificationService.$inject = ['$http', '$mdDialog', '$mdToast'];

	function bizNotificationProvider(notificationSettingType) {
		function getView() {
			switch (notificationSettings.Type) {
				case notificationSettingType.FAB:
					return 'FrontEnd/Core/Directives/Views/NotificationsFAB.html';
				case notificationSettingType.STANDARD:
					return 'FrontEnd/Core/Directives/Views/Notifications.html';
				case notificationSettingType.DIALOG:
					return 'FrontEnd/Core/Directives/Views/NotificationsDialog.html';
					break;
			}
		}

		return {
			getView: getView,
			$get: function () {
				return {
					getView: getView,
				};
			},
		};
	}

	function bizNotifications(
		bizCoreProvider,
		bizNotificationProvider,
		notificationSettingType,
		notificationPosition,
		bizNotificationService
	) {
		var directive = {
			restrict: 'E',
			scope: {},
			templateUrl: bizCoreProvider.getView('core.directives.notifications', bizNotificationProvider.getView()),
			controller: bizNotificationsController,
			controllerAs: 'vm',
		};

		bizNotificationsController.$inject = [
			'$rootScope',
			'$timeout',
			'$translate',
			'bizNotificationService',
			'$state',
			'bizEffects',
			'$transitions',
			'core.engage.service',
			'bizJourneyService',
			'bizUser',
		];

		function bizNotificationsController(
			$rootScope,
			$timeout,
			$translate,
			bizNotificationService,
			$state,
			bizEffects,
			$transitions,
			coreEngageService,
			bizJourneyService,
			bizUser
		) {
			var vm = this;
			vm.Fade = false;
			vm.IsPulsating = false;
			vm.CanFade = true;
			vm.DoGroup = false;
			vm.ShowNotifications = false;
			vm.FadeTimer = 6000;
			vm.Notifications = [];
			vm.GroupedNotifications = [];
			vm.FirstItemOfType = [];
			vm.Settings = notificationSettings;
			vm.Settings.Mascot = mascot;
			vm.MaxSubItemsLength = 5;
			vm.SubItemsGroupWithinSecounds = 3600;
			vm.MaxNotificationsToShow = 1;

			vm.AddNotification = AddNotification;
			vm.StartFadeTimer = StartFadeTimer;
			vm.CancelFadeTimer = CancelFadeTimer;
			vm.GetNotifications = GetNotifications;
			vm.GetPositionClass = GetPositionClass;
			vm.SetFade = SetFade;
			vm.GetHighestId = GetHighestId;
			vm.Pulsate = Pulsate;
			vm.StopPulsating = StopPulsating;
			vm.SetProperties = SetProperties;
			vm.GoToItem = GoToItem;
			vm.IsHighlighted = IsHighlighted;
			vm.InitSlick = InitSlick;
			vm.ExistInSubitems = ExistInSubitems;
			vm.GroupNotifications = GroupNotifications;
			vm.UnHighlightAllNotifications = UnHighlightAllNotifications;
			vm.NavigateTo = NavigateTo;
			vm.SetUrlRewrite = SetUrlRewrite;

			//keeping this method around, useful for testing
			vm.FakeMessageForTesting = FakeMessageForTesting;
			function FakeMessageForTesting(key, msg, objectType, settings) {
				var content = {
					Key: key || 'ENGAGE_OBJECT_DONE',
					Message: msg || 'You have completed X',
					NotificationId: getRandomInt(),
					ObjectType: objectType || 'MediabankFile',
					Settings: settings,
					Show: true,
				};

				vm.AddNotification(undefined, {
					Content: JSON.stringify(content),
				});

				function getRandomInt(min, max) {
					var min = 1000000;
					var max = 9999999;
					return Math.floor(Math.random() * (max - min) + min);
				}
			}

			function InitSlick() {
				vm.SlickLoaded = false;
				vm.SlickSettings = {
					arrows: false,
					dots: true,
					infinite: false,
					slidesToShow: 1,
					slidesToScroll: 1,
				};
				$timeout(function () {
					vm.SlickLoaded = true;
				});
			}

			// $timeout(function() {
			//     vm.AddNotification(null, {
			//         NotificationId: 'abc',
			//         HubKey: "USER_NOTIFICATION",
			//         Content: JSON.stringify({
			//             Key: "ENGAGE_OBJECT_DONE",
			//             Message: "Detta är ett test meddelande...",
			//             Subject: "Test subject"
			//         }),
			//         Settings: JSON.stringify({

			//         })
			//     });
			// }, 2500);

			function AddNotification(event, not) {
				if (!not.Content) return;

				var notification = JSON.parse(not.Content);

				//to avoid dupes and/or missing notifications (as they also arrive via ws)
				if (
					vm.Notifications.GetItemByValue('NotificationId', notification.NotificationId) ||
					vm.ExistInSubitems(notification.NotificationId)
				)
					return;

				if (vm.LatestNotification?.Show) {
					if (!vm.Queue) vm.Queue = [];
					vm.Queue.push(not);
					return;
				}

				notification.Show = true;
				if (notification.Settings) {
					notification.Settings = JSON.parse(notification.Settings);
				}

				vm.Notifications.unshift(notification);
				vm.GroupNotifications();

				vm.StartFadeTimer(notification);
				vm.SetFade(false);
				vm.Pulsate();

				vm.SetUrlRewrite(notification);

				vm.LatestNotification = angular.copy(notification);

				if (notification.Settings && notification.Settings.Effect) {
					TriggerEffect(notification.Settings.Effect);
				}

				$timeout(function () {
					vm.LatestNotification.Show = false;
					if (vm.Queue?.length > 0) {
						var queueNotification = vm.Queue.shift();
						$timeout(() => {
							vm.AddNotification(undefined, queueNotification);
						}, 1000);
					}
				}, 8000);
			}

			function TriggerEffect(effect) {
				bizEffects.Show(effect);
			}

			function GetHighestId() {
				var id = 0;
				for (var i = 0; i < vm.Notifications.length; i++) {
					if (vm.Notifications[i].NotificationId > id) {
						id = vm.Notifications[i].NotificationId;
					}
				}
				return id;
			}

			function StartFadeTimer(notification) {
				notification.FadeTimer = $timeout(function () {
					notification.FadeTimer = undefined;
					notification.Fading = $timeout(function () {
						notification.Fading = undefined;
						notification.Show = false;
					}, 2000);
				}, vm.FadeTimer);
			}

			function CancelFadeTimer(notification) {
				if (notification.FadeTimer) {
					$timeout.cancel(notification.FadeTimer);
					notification.FadeTimer = undefined;
				}
				if (notification.Fading) {
					$timeout.cancel(notification.Fading);
					notification.Fading = undefined;
				}
			}

			function ExistInSubitems(id) {
				for (var g = 0; g < vm.GroupedNotifications.length; g++) {
					if (vm.GroupedNotifications[g].Items !== undefined) {
						for (var gi = 0; gi < vm.GroupedNotifications[g].Items.length; gi++) {
							if (vm.GroupedNotifications[g].Items[gi].NotificationId == id) {
								return true;
							}
						}
					}
				}

				return false;
			}

			function GroupNotifications() {
				if (!vm.DoGroup) {
					vm.GroupedNotifications = vm.Notifications.slice();
					return;
				}

				var grouped = [];

				for (var index = 0; index < vm.Notifications.length; index++) {
					var not = vm.Notifications[index];
					var subItems = [not];

					var nextIndex;
					var groupNext = true;
					for (nextIndex = index + 1; nextIndex < vm.Notifications.length && groupNext; nextIndex++) {
						var nextNot = vm.Notifications[nextIndex];
						var sameKey = not.Key === nextNot.Key;
						var duration = moment.duration(moment(not.DateSent).diff(nextNot.DateSent));
						var seconds = duration.asSeconds();
						var withinTime = seconds < vm.SubItemsGroupWithinSecounds;

						if (sameKey && withinTime && subItems.length < vm.MaxSubItemsLength) {
							subItems.push(nextNot);
						} else if (sameKey && withinTime) {
							//DO NOTHING... ELSE WE GROUP THE NEXT ONES BELOW...
						} else {
							groupNext = false;
						}
					}

					if (subItems.length == 1) {
						grouped.push(subItems[0]);
					} else {
						grouped.push({
							NotificationId: not.NotificationId,
							Items: subItems,
						});
						var extraItemsAddedInMainLoop = subItems.length - 1;
						index = index + extraItemsAddedInMainLoop;
					}
				}
				vm.GroupedNotifications = grouped;
				console.log(vm.GroupedNotifications);

				vm.InitSlick();
			}

			function GetNotifications() {
				if (IsPortalSettingTrue('IsUserNotificationsEnabled') && bizUser.IsLoggedIn())
					bizNotificationService.GetLoggedInUserNotifications(10, 1).then(GetLoggedInUserNotificationsSuccess);

				function GetLoggedInUserNotificationsSuccess(response) {
					var notificationsFromServer = response.data;
					if (vm.Notifications.length > 0) {
						//to avoid dupes and/or missing notifications (as they also arrive via signalr)
						for (var i = 0; i < notificationsFromServer.length; i++) {
							if (!vm.Notifications.GetItemByValue('NotificationId', notificationsFromServer[i].NotificationId)) {
								vm.Notifications.push(notificationsFromServer[i]);
							}
						}
					} else {
						vm.Notifications = response.data;
					}

					vm.GroupNotifications();

					vm.SetProperties();
					vm.SetUrlRewrite();
				}
			}

			function GetPositionClass() {
				switch (vm.Settings.Position) {
					case notificationPosition.TOPLEFT:
						return 'top-left';
					case notificationPosition.TOPRIGHT:
						return 'top-right';
					case notificationPosition.BOTTOMLEFT:
						return 'bottom-left';
					case notificationPosition.BOTTOMRIGHT:
						return 'bottom-right';
					case notificationPosition.CENTER:
						return 'center';
				}
			}

			function SetFade(val, action) {
				if (val === true && vm.CanFade === true && vm.ShowNotifications === false && vm.IsPulsating === false) {
					vm.Fade = true;
				} else {
					if (action === 'hover' && $rootScope.GetMiniSetting('Notifications', 'ShowOnMouseOver') === false) {
						return;
					}

					vm.Fade = false;
					$timeout(
						function (vm) {
							vm.SetFade(true);
						},
						vm.FadeTimer,
						true,
						vm
					);
				}
			}

			function Pulsate(time) {
				vm.IsPulsating = true;

				if (~~time > 0) {
					$timeout(
						function (vm) {
							vm.StopPulsating();
						},
						time,
						true,
						vm
					);
				}
			}

			function StopPulsating() {
				vm.IsPulsating = false;
			}

			function SetProperties() {
				for (var i = 0; i < vm.Notifications.length; i++) {
					if (
						vm.Notifications[i].ConfirmRead == false ||
						moment(vm.Notifications[i].DateSent).isAfter(moment().subtract(1, 'minutes'))
					) {
						vm.Pulsate();
					}
				}
			}

			function SetUrlRewrite(item) {
				var engageObjectList = [];
				for (var i = 0; i < vm.Notifications.length; i++) {
					if (
						(!item ||
							(item.ObjectType === vm.Notifications[i].ObjectType &&
								item.ObjectId === vm.Notifications[i].ObjectId)) &&
						coreEngageService.IsEngageObject(vm.Notifications[i].ObjectType)
					) {
						engageObjectList.push({
							Id: vm.Notifications[i].ObjectId,
							EngageObjectType: vm.Notifications[i].ObjectType,
						});
					}
				}

				coreEngageService.GetEngageObjectsByObjectIdAndType(engageObjectList).then(GetEngageObjectsCallback);

				function GetEngageObjectsCallback(response) {
					var result = BizPartCoreHelpers.getResponseValue(response);
					for (var i = 0; i < result.length; i++) {
						if (result[i].UrlRewrite) {
							for (var j = 0; j < vm.Notifications.length; j++) {
								if (
									vm.Notifications[j].ObjectId === result[i].Id &&
									coreEngageService.GetEngageObjectTypeId(vm.Notifications[j].ObjectType) ===
										result[i].EngageObjectType
								) {
									vm.Notifications[j].ObjectUrlRewrite = result[i].UrlRewrite;
									if (
										vm.LatestNotification &&
										vm.Notifications[j].NotificationId === vm.LatestNotification.NotificationId
									) {
										vm.LatestNotification.ObjectUrlRewrite = result[i].UrlRewrite;
									}
								}
							}
						}
					}
				}
			}

			function GoToItem(item) {
				//The types that should be clickable for any user (as long as they have access, which should be fixed on backend)
				if (coreEngageService.IsEngageObject(item.ObjectType)) {
					if (item.ObjectUrlRewrite) {
						coreEngageService.RedirectToEngageObject(item.ObjectType, item.ObjectUrlRewrite);
					} else {
						coreEngageService.RedirectToEngageObject(item.ObjectType, item.ObjectId);
					}
					return;
				}

				//The types that only should be clickable for the users own items
				if (
					item.Settings &&
					~~item.Settings.ObjectOwnerUserId > 0 &&
					item.Settings.ObjectOwnerUserId === $rootScope.LoggedInUser.Id
				) {
					switch (item.ObjectType) {
						case 'GOAL':
							vm.NavigateTo('base.modules.goals.onegoal', { id: ~~item.ObjectId > 0 ? ~~item.ObjectId : 'new' });
							break;
						case 'TODO':
							vm.NavigateTo('base.modules.goals.onetask', { id: ~~item.ObjectId > 0 ? ~~item.ObjectId : 'new' });
							break;
						case 'ACTIVITY':
							vm.NavigateTo('base.modules.goals.activity', { id: ~~item.ObjectId > 0 ? ~~item.ObjectId : 'new' });
							break;
						case 'ACTIVITYFORGOAL':
							vm.NavigateTo('base.modules.goals.activityforgoal', { goalId: ~~item.ObjectId });
							break;
					}
				}

				if (item.Key === 'JOURNEY_COMPLETED') {
					if (item.Settings && item.Settings.Data && !item.Settings.Data.FeedbackLink) return;
					bizJourneyService.GetJourneySettings().then(GetJourneySettingsCallback);
					function GetJourneySettingsCallback(response) {
						var journeySettings = response.data;
						var feedbackPage = journeySettings.FeedbackPage;
						if (feedbackPage) {
							vm.NavigateTo('base.modules.cms', {
								id: feedbackPage,
								params: { objectKey: 'JOURNEY', objectId: ~~item.ObjectId },
							});
						}
					}
				}
			}

			function NavigateTo(state, params) {
				$state.go(state, params);
				//vm.ShowNotifications = false;
				//if(vm.LatestNotification) {
				//    vm.LatestNotification.Show = false;
				//}
			}

			function UnHighlightAllNotifications() {
				for (var i = 0; i < vm.SortedNotifications.length; i++) {
					vm.SortedNotifications[i].NoHighlight = true;
				}
			}

			function IsHighlighted(index) {
				if (vm.MaxNotificationsToShow <= 1) {
					return false;
				}

				if (vm.SortedNotifications) {
					if (vm.SortedNotifications[index].NoHighlight) {
						return false;
					}

					if (index == 0) return true;

					if (index > 0 && vm.SortedNotifications[index].Key !== undefined) {
						var duration = moment.duration(
							moment(vm.SortedNotifications[0].DateSent).diff(vm.SortedNotifications[index].DateSent)
						);
						var seconds = duration.asSeconds();

						if (seconds < 120) return true;
					}
				}

				return false;
			}

			function Init() {
				$rootScope.$on('HUB_USER_NOTIFICATION', vm.AddNotification);

				vm.GetNotifications();

				$timeout(
					function (vm) {
						vm.SetFade(true);
					},
					3000,
					true,
					vm
				);

				//$timeout(function (vm) {
				//    vm.SetFade(true);
				//}, vm.FadeTimer, true, vm);

				//$timeout(() => {
				//    var settings = {
				//        EmojiIcon: '🥳'
				//    };
				//    vm.FakeMessageForTesting(undefined, undefined, undefined, JSON.stringify(settings));
				//}, 2000);

				//$timeout(() => {
				//    vm.FakeMessageForTesting(undefined, "Another new message");
				//}, 5000);
			}

			vm.$onInit = Init;

			//hide notifications when going to another page
			$transitions.onStart({}, function () {
				vm.ShowNotifications = false;
				if (vm.LatestNotification) {
					vm.LatestNotification.Show = false;
				}
			});

			// hide notifications on speedquiz-play @ mobile
			$rootScope.$watch('CurrentState', function (newVal, oldVal) {
				if (newVal && newVal != oldVal && $rootScope.CurrentState && $rootScope.mobile === true) {
					if ($rootScope.CurrentState.name === 'base.modules.speedquizplay') {
						$('biz-notifications').hide();
					} else {
						$('biz-notifications').show();
					}
				}
			});
		}

		return directive;
	}

	function bizNotificationService($http, $mdDialog, $mdToast) {
		this.GetLoggedInUserNotifications = function (max, page) {
			return $http.get(siteRootPath + 'api/user/GetLoggedInUserNotifications?' + $.param({ max: max, page: page }));
		};

		this.CustomNotificationHandlers = {
			POPUP: {
				Enabled: true,
				Handler: PopupNotificationHandler,
			},
			CUSTOM: {
				Enabled: true,
				Handler: CustomNotificationHandler,
			},
		};

		function CustomNotificationHandler(notification) {
			var template = '<md-toast class="custom-notification">' + notification.Message + '</md-toast>';
			$mdToast.show({
				position: 'top center',
				parent: angular.element(document.body),
				hideDelay: 20000,
				template: template,
				autoWrap: true,
				controllerAs: 'vm',
				controller: function ($mdToast) {
					var vm = this;
					vm.close = function () {
						$mdToast.hide();
					};
				},
			});
		}

		function PopupNotificationHandler(notification) {
			$mdDialog.show({
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				templateUrl: siteRootPath + 'FrontEnd/Core/Directives/Views/PopupNotification.html',
				controllerAs: 'vm',
				bindToController: true,
				multiple: true,
				skipHide: true,
				controller: PopupNotificationController,
				locals: {
					Notification: notification,
				},
			});

			function PopupNotificationController() {
				var vm = this;

				vm.Close = Close;

				function Close() {
					$mdDialog.hide();
				}
			}
		}
	}
})(window.angular);
